import React, { useCallback, useEffect, useState } from 'react';
import { MdNotificationsActive } from 'react-icons/md';
import { Button, Form, FormCheck, Modal, Spinner, Table } from 'react-bootstrap';
import { useContext } from 'react';
import MyContext from '../../MyContext';
import { GET_PRODUCTS, STOCK_ALMOST_GONES } from '../../apollo/product/query';
import { APP_COLOR, LINEAR_GRADIENT_BG, USER_KEY } from '../../const';
import { useDispatch, useSelector } from 'react-redux';
import { useLazyQuery, useMutation } from '@apollo/client';
import { addStockAlmostGones } from '../../redux/reducers/stockAlmostGonesReducer';
import PaginationsV2 from '../../components/PaginationsV2';
import BreadCrumbComponent from '../../components/BreadCrumbComponent';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import AnimationLoading from '../../components/Animationloading';
import { successSwal } from '../../helper/sweetalert';
import PaginationHelper from "../../components/PaginationHelper";
import { UPDATE_MANY_PRODUCT } from '../../apollo/product/Mutation';
import CustomButton from '../../components/CustomButton';
import EmptyComponent from '../../components/EmptyComponent';

export default function Stocknotification() {
    const history = useHistory();
    const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const { _limit, _skip, Pagination_helper } = PaginationHelper();
    const [showEditMany, setShowEditMany] = useState(false);
    const [editTitle, setEditTitle] = useState();
    const [Products, setProducts] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isEditProducts, setIsEditProducts] = useState(false);
    const [amount, setAmount] = useState("");
    const { notificationProduct, notificationTotal, setNotificationTotal } = useContext(MyContext);
    const dispatch = useDispatch();
    const user_data = JSON.parse(localStorage.getItem(USER_KEY));
    // const { stockAlmostGones } = useSelector((state) => state.stock);
    const [role, setRole] = useState();


    const [loadStockAlmostGones, { data: stockAlmostData }] =
        useLazyQuery(STOCK_ALMOST_GONES, { fetchPolicy: "network-only" });


    const [updateManyProduct, { loading: loadingUpdateStock }] = useMutation(UPDATE_MANY_PRODUCT);
    const rowsPerPage = 20;
    const [page, setPage] = useState(0);
    const pageAll = Math.ceil(notificationTotal / rowsPerPage) || 1;
    const handleChangePage = useCallback((newPage) => {
        setPage(newPage);
    }, []);

    useEffect(() => {
        fetchDataMostGones()
    }, [shopId, page]);


    const fetchDataMostGones = () => {
        loadStockAlmostGones({
            variables: {
                skip: page * rowsPerPage,
                limit: rowsPerPage,
                orderBy: "createdAt_DESC",
                where: {
                    shop: shopId,
                },
            },
        });
    }



    useEffect(() => {
        if (stockAlmostData?.stockAlmostGones?.data) {
            dispatch(addStockAlmostGones(stockAlmostData?.stockAlmostGones?.data));
        }
    }, [stockAlmostData?.stockAlmostGones?.data]);

    useEffect(() => {
        if (stockAlmostData?.stockAlmostGones?.total) {
            setNotificationTotal(stockAlmostData?.stockAlmostGones?.total);
        }
    }, [stockAlmostData?.stockAlmostGones?.total]);



    useEffect(() => {
        if (stockAlmostData?.stockAlmostGones?.data) {
            setProducts(stockAlmostData?.stockAlmostGones?.data);
        }
    }, [stockAlmostData?.stockAlmostGones?.data]);


    // useEffect(() => {
    //     _filter();
    // }, [_skip]);

    // const _filter = async () => {
    //     let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    //     let _where = {
    //         shop: shopId,
    //         isDeleted: false,
    //     };
    // };


    useEffect(() => {
        if (user_data) {
            setRole(user_data?.data?.role);
        }
    }, [user_data]);

    const handleCheckboxChange = (event) => {
        const itemId = event.target.value;
        console.log("item", itemId)
        if (itemId !== "") {
            setIsEditProducts(true);
            setSelectedItems((prevSelectedItems) => {
                if (prevSelectedItems.includes(itemId)) {
                    return prevSelectedItems.filter((id) => id !== itemId);
                } else {
                    return [...prevSelectedItems, itemId];
                }
            });
        } else {
            setIsEditProducts(false);
        }
    };

    // const handleCheckboxChange = (event) => {
    //     const itemId = event.target.value;
    //     console.log("item", itemId)
    //     if (itemId !== "") {
    //         setIsEditProducts(true);
    //         setSelectedItems((prevSelectedItems) => {
    //             if (prevSelectedItems.includes(itemId)) {
    //                 return prevSelectedItems.filter((id) => id !== itemId);
    //             } else {
    //                 return [...prevSelectedItems, itemId];
    //             }
    //         });
    //     } else {
    //         setIsEditProducts(false);
    //     }
    // };


    const toggleSelectAll = () => {
        if (isSelectAll) {
            setSelectedItems([]);
        } else {
            setSelectedItems(Products.map(product => product._id));
        }
        setIsSelectAll(!isSelectAll);
    };

    const _editManyProduct = async () => {
        try {
            if (loadingUpdateStock) return;
            const res = await updateManyProduct({
                variables: {
                    where: {
                        id_in: selectedItems,
                    },
                    data: {
                        amount: parseInt(amount),
                        shop: shopId
                    },
                },
            });

            if (res) {
                // _filter();
                setSelectedItems([]);
                setShowEditMany(false);
                setEditTitle();
                setIsSelectAll(false);
                fetchDataMostGones()
                handleClose()
                setAmount()
                successSwal("ເເກ້ໄຂຂໍ້ມູນທັງໝົດສຳເລັດ");
            }
        } catch (error) {
            console.log("error: ", error);
            throw Error(error);
        }
    };

    return (
        <React.Fragment>
            <BreadCrumbComponent goback={history.goBack} txtSecond={`ແຈ້ງເຕືອນສິນຄ້າ`} />
            <div style={{ padding: "0 1em" }}>
                <h4>
                    <b>ແຈ້ງເຕືອນສິນຄ້າໃກ້ໝົດ</b>
                </h4>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span >ລາຍການຈຳນວນສິນຄ້າໃກ້ຫມົດ
                        <span style={{ color: 'red', marginLeft: "5px" }}>({notificationTotal || 0})</span></span>
                    <div>
                            <CustomButton
                                disabled={selectedItems.length === 0}
                                height={40}
                                background={selectedItems.length > 0 ? LINEAR_GRADIENT_BG : "#dddd"}
                                width={150}
                                borderRadius={8}
                                title={`ແກ້ໄຂ`}
                                color={selectedItems.length === 0 ? "black" : "#dddd"}
                                onClick={selectedItems.length > 0 ? handleShow : null}
                            />
                    </div>
                </div>

            </div>

            <div className='p-4'>

                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th style={{ display: 'flex' }}>
                                <FormCheck
                                    style={{ marginRight: "1rem" }}
                                    aria-label="option 1"
                                    checked={isSelectAll}
                                    onChange={toggleSelectAll}
                                />
                                ລຳດັບ
                            </th>
                            <th>ບຣາໂຄດ</th>
                            <th>ຊື່ສິນຄ້າ</th>
                            <th>ສິນຄ້າຄົງເຫລືອ</th>
                        </tr>
                    </thead>

                    {!stockAlmostData ? (
                        <tbody>
                            <tr>
                                <td colSpan={4}>
                                    <AnimationLoading />
                                </td>
                            </tr>
                        </tbody>
                    ) : (
                        <tbody>
                            {Products.length === 0 ? (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: 'center' }}>
                                        <EmptyComponent />
                                        <p>ຍັງບໍ່ມີສິນຄ້າໃກ້ໝົດ !!!</p>
                                    </td>
                                </tr>
                            ) : (
                                Products.map((notic, index) => (

                                    <tr key={index}>
                                        <td style={{ display: 'flex', }}>
                                                <FormCheck
                                                    style={{ marginRight: "1rem" }}
                                                    aria-label="option 1"
                                                    value={notic?._id}
                                                    checked={selectedItems.includes(notic?._id)}
                                                    onChange={handleCheckboxChange}
                                                />
                                            {page * rowsPerPage + index + 1}
                                        </td>
                                        <td>{notic.barCode ?? "-"}</td>
                                        <td>{notic.name}</td>
                                        <td style={{ color: "red" }}>{notic.amount}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    )}



                </Table>
                <div className="d-flex justify-content-end align-items-end w-100">
                    {stockAlmostData &&
                        <PaginationsV2
                            count={notificationTotal}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            pageAll={pageAll}
                            onPageChange={handleChangePage}
                        />}
                </div>
            </div>





            {/* modals update stocks ----------------> */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>ແກ້ໄຂຈຳນວນສິນຄ້າຄົງເຫລືອ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>ເພີ່ມຈຳນວນສິນຄ້າ</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="ຈຳນວນສິນຄ້າ"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        ຍົກເລີກ
                    </Button>
                    <Button variant="primary"
                        onClick={_editManyProduct}
                        title={loadingUpdateStock ? <Spinner /> : " ບັນທຶກ"}
                    >
                        ບັນທຶກ
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    );
}
